/*
 * @Author: 张宇 1204569549@qq.com
 * @Date: 2021-09-24 09:37:43
 * @LastEditors: 张宇 1204569549@qq.com
 * @LastEditTime: 2022-10-22 17:08:39
 * @FilePath: \screening-sys\src\utils\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Cookies from 'js-cookie';
var TokenKey = process.env.VUE_APP_ADMIN_TOKEN_KEY;
var UserNameKey = 'ANS-Admin-User-Name';
var SchoolKey = 'ANS-Admin-School-Id';
var SchoolNameKey = 'ANS-Admin-School-Name';
var RolesKey = 'ANS-Admin-Roles';
var SubAccountNoKey = 'ANS-Sub-Account-No';
var handleIsCheckOpen = 'ANS-handle-Is-Check-Open';
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function getUserName() {
  return Cookies.get(UserNameKey);
}
export function setUserName(user_name) {
  return Cookies.set(UserNameKey, user_name);
}
export function removeUserName() {
  return Cookies.remove(UserNameKey);
}
export function getSchoolId() {
  return Cookies.get(SchoolKey);
}
export function setSchoolId(school_id) {
  return Cookies.set(SchoolKey, school_id);
}
export function removeSchoolId() {
  return Cookies.remove(SchoolKey);
}
export function getSchool() {
  return Cookies.get(SchoolNameKey);
}
export function setSchool(school) {
  return Cookies.set(SchoolNameKey, school);
}
export function removeSchool() {
  return Cookies.remove(SchoolNameKey);
}
export function getRoles() {
  return Cookies.get(RolesKey);
}
export function setRoles(roles) {
  return Cookies.set(RolesKey, roles);
}
export function removeRoles() {
  return Cookies.remove(RolesKey);
}
export function getSubAccountNo() {
  return Cookies.get(SubAccountNoKey);
}
export function setSubAccountNo(isChildNo) {
  return Cookies.set(SubAccountNoKey, isChildNo);
}
export function removeSubAccountNo() {
  return Cookies.remove(SubAccountNoKey);
}
export function getIsCheckOpen() {
  return Cookies.get(handleIsCheckOpen);
}
export function setIsCheckOpen(ischeckopen) {
  return Cookies.set(handleIsCheckOpen, ischeckopen);
}
export function removeIsCheckOpen() {
  return Cookies.remove(handleIsCheckOpen);
}